




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition } from '@/plugins/podolib/services/entities/EntityPatients';

import AnalysisStepConditionsWalkingAidsDialog from '@/components/analysis/steps/conditions/AnalysisStepConditionsWalkingAidsDialog.vue';
import AnalysisStepConditionsShoesTypeDialog from '@/components/analysis/steps/conditions/AnalysisStepConditionsShoesTypeDialog.vue';
import AnalysisStepConditionsPainsDialog from '@/components/analysis/steps/conditions/AnalysisStepConditionsPainsDialog.vue';
import {
  ConditionsWalkingAidDevices,
  StepConditions,
} from '@/components/analysis/steps/conditions/AnalysisStepConditions';

@Component({
  components: {
    AnalysisStepConditionsPainsDialog,
    AnalysisStepConditionsWalkingAidsDialog,
    AnalysisStepConditionsShoesTypeDialog,
  },
})
export default class PatientAcquisitionConditions extends Vue {
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;
  @Prop({ required: true }) private isAcquisitionPage!: boolean;

  internalWalkingAids: any;

  get pains() {
    return {
      data: this.acquisition?.conditions?.pains,
      key: 'analysis.steps.conditions.pains',
    };
  }
  get shoesType() {
    return {
      data: this.acquisition?.conditions?.shoes_type,
      key: 'analysis.steps.conditions.shoes_type',
    };
  }
  get walkingAids() {
    return {
      data: this.acquisition?.conditions?.walking_aids,
      key: 'analysis.steps.conditions.walking_aids',
    };
  }

  getWalkingAidName(value: string) {
    const result = this.internalWalkingAids.find((x: any) => x.value === value).text;
    if (result) return result;
    return value;
  }

  // Pain
  addAcquisitionConditionPain() {
    if (this.isAcquisitionPage) this.$pdc.bus!.emit('analysis:conditions-pains:add', 'add');
  }
  editAcquisitionConditionPain(id: number) {
    if (this.isAcquisitionPage) this.$pdc.bus!.emit('analysis:conditions-pains:edit', 'edit', { id });
  }

  // Walking aids
  addAcquisitionConditionWalkingAids() {
    if (this.isAcquisitionPage) (this.$refs.walking_aids as any)._open('add');
  }

  // Shoes type
  addAcquisitionConditionShoesType() {
    if (this.isAcquisitionPage) (this.$refs.shoes_type as any)._open('add');
  }
  editAcquisitionConditionShoesType() {
    if (this.isAcquisitionPage) (this.$refs.shoes_type as any)._open('edit');
  }

  removePain(id: string) {
    try {
      this.$pdc.repository?.patchRessource({
        ressource: 'acquisitions',
        params: {
          _id: this.acquisition._id,
        },
        data: {
          $pull: {
            'conditions.pains': {
              _id: id,
            },
          },
        },
      });
    } catch (e) {
      console.log(e);
    }
  }
  removeShoesType() {
    try {
      this.$pdc.repository?.patchRessource({
        ressource: 'acquisitions',
        params: {
          _id: this.acquisition._id,
        },
        data: {
          $unset: {
            'conditions.shoes_type': '',
          },
        },
      });
    } catch (e) {
      console.log(e);
    }
  }
  removeWalkingAid(name: string) {
    try {
      this.$pdc.repository?.patchRessource({
        ressource: 'acquisitions',
        params: {
          _id: this.acquisition._id,
        },
        data: {
          $pull: {
            'conditions.walking_aids': name,
          },
        },
      });
    } catch (e) {
      console.log(e);
    }
  }

  getPainLevelType(stringLevel: string) {
    const level = parseFloat(stringLevel);
    if (level <= 3) {
      return {
        class: 'label-good',
        color: 'rgb(42, 191, 143)',
      };
    } else if (level > 3 && level < 8) {
      return {
        class: 'label-warning',
        color: 'rgb(255, 179, 26)',
      };
    } else {
      return {
        class: 'label-bad',
        color: 'rgb(255, 94, 26)',
      };
    }
  }

  created() {
    this.internalWalkingAids = this.$pdc.helper!.enumToArrayAndTranslate(ConditionsWalkingAidDevices, {
      key: 'analysis.steps.conditions.walking_aids',
    });
  }
}
